import Vue from 'vue'
import { Locale } from 'vant';
import VueI18n from 'vue-i18n'
// 中文包
import zhCN from 'vant/es/locale/lang/zh-CN'
// 英语包
import enUS from 'vant/es/locale/lang/en-US';
// 法语包
import frFR from 'vant/es/locale/lang/fr-FR';
// 德语包
import deDE from 'vant/es/locale/lang/de-DE';
// 西班牙语包
import esES from 'vant/es/locale/lang/es-ES';

// 自定义语言库
import zhLocale from './zh'  // 中文
import enLocale from './en'  // 英语
import itLocale from './it'  // 意大利语
import frLocale from './fr'  // 法语
import deLocale from './de'  // 德语
import esLocale from './es'  // 西班牙语

Vue.use(VueI18n)

let messages = {
    'zh': {
        ...zhCN,
        ...zhLocale
    },
    'en': {
        ...enUS,
        ...enLocale
    },
    'it': {
        ...enUS,
        ...itLocale
    },
    'fr': {
        ...frFR,
        ...frLocale
    },
    'de': {
        ...deDE,
        ...deLocale
    },
    'es': {
        ...esES,
        ...esLocale
    }
}

// 获取语言
function getLanguage () {
    let language = navigator.language || navigator.userLanguage;//常规浏览器语言和IE浏览器
    if (!language) {
        return {
            defaultLang: 'en',
            abbrLang: 'en'
        }
    }
    let langStr = language.slice(0, 2);//截取lang前2位字符
    let defaultLang = ''
    let abbrLang = ''
    switch (langStr) {
        case 'zh':
            defaultLang = 'zh-CN'
            abbrLang = 'zh'
            break;
        case 'en':
            defaultLang = 'en'
            abbrLang = 'en'
            break;
        case 'it':
            defaultLang = 'it'
            abbrLang = 'it'
            break;
        case 'fr':
            defaultLang = 'fr'
            abbrLang = 'fr'
            break;
        case 'de':
            defaultLang = 'de'
            abbrLang = 'de'
            break;
        case 'es':
            defaultLang = 'es'
            abbrLang = 'es'
            break;
        default:
            defaultLang = 'en'
            abbrLang = 'en'
    }
    return {
        defaultLang,
        abbrLang
    }
}
let lang = getLanguage()
localStorage.setItem('Language', lang.defaultLang)

const i18n = new VueI18n({
  locale: lang.abbrLang,  // 设置默认语言
  messages: messages // 设置资源文件对象
})

// 更新vant组件库本身的语言变化，支持国际化
function vantLocales (lang) {
  if (lang === 'zh') {
    Locale.use(lang, zhCN)
  } else if (lang === 'en') {
    Locale.use(lang, enUS)
  } else if (lang === 'it') {
    Locale.use(lang, enUS)
  } else if (lang === 'fr') {
    Locale.use(lang, frFR)
  } else if (lang === 'de') {
    Locale.use(lang, deDE)
  } else if (lang === 'es') {
    Locale.use(lang, esES)
  }
}

export {i18n, vantLocales}
